/* unplugin-vue-components disabled */import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "buttonDiv"
};
export default {
  __name: 'viewerButton',
  setup(__props) {
    const pageData = inject("pageData");
    const onUpdateviewerClass = inject("onUpdateviewerClass");
    const text = ref("");
    const prompt = a => {
      text.value = a;
    };
    return (_ctx, _cache) => {
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_text, {
        style: {
          "color": "#000"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(text)), 1)]),
        _: 1
      }), _withDirectives((_openBlock(), _createElementBlock("svg", {
        class: "talkButton",
        onClick: _cache[0] || (_cache[0] = $event => _unref(onUpdateviewerClass)('minTalking')),
        onMouseover: _cache[1] || (_cache[1] = $event => prompt('將大小视图进行切换')),
        onMouseout: _cache[2] || (_cache[2] = $event => text.value = ''),
        width: "28",
        height: "28",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...(_cache[10] || (_cache[10] = [_createElementVNode("path", {
        d: "M9.85786 32.7574C6.23858 33.8432 4 35.3432 4 37C4 40.3137 12.9543 43 24 43C35.0457 43 44 40.3137 44 37C44 35.3432 41.7614 33.8432 38.1421 32.7574",
        stroke: "#333",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M24 35C24 35 37 26.504 37 16.6818C37 9.67784 31.1797 4 24 4C16.8203 4 11 9.67784 11 16.6818C11 26.504 24 35 24 35Z",
        fill: "none",
        stroke: "#333",
        "stroke-width": "4",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M24 22C26.7614 22 29 19.7614 29 17C29 14.2386 26.7614 12 24 12C21.2386 12 19 14.2386 19 17C19 19.7614 21.2386 22 24 22Z",
        fill: "#333",
        stroke: "#333",
        "stroke-width": "4",
        "stroke-linejoin": "round"
      }, null, -1)]))], 544)), [[_vShow, _unref(pageData).showMin & _unref(pageData).maxShow]]), _withDirectives((_openBlock(), _createElementBlock("svg", {
        class: "talkButton",
        onClick: _cache[3] || (_cache[3] = $event => _unref(onUpdateviewerClass)('maxTalking')),
        onMouseover: _cache[4] || (_cache[4] = $event => prompt('將大小视图进行切换')),
        onMouseout: _cache[5] || (_cache[5] = $event => text.value = ''),
        width: "28",
        height: "28",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...(_cache[11] || (_cache[11] = [_createElementVNode("rect", {
        x: "6",
        y: "6",
        width: "36",
        height: "36",
        rx: "3",
        fill: "none",
        stroke: "#333",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M18.5 24V16.2058L25.25 20.1029L32 24L25.25 27.8971L18.5 31.7942V24Z",
        fill: "#fff",
        stroke: "#fff",
        "stroke-width": "4",
        "stroke-linejoin": "round"
      }, null, -1)]))], 544)), [[_vShow, _unref(pageData).showMin & !_unref(pageData).maxShow]]), _withDirectives((_openBlock(), _createElementBlock("svg", {
        class: "talkButton",
        onClick: _cache[6] || (_cache[6] = $event => _unref(onUpdateviewerClass)('notShowMin')),
        onMouseover: _cache[7] || (_cache[7] = $event => prompt('最小化到下方，隐藏小视图')),
        onMouseout: _cache[8] || (_cache[8] = $event => text.value = ''),
        width: "24",
        height: "24",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...(_cache[12] || (_cache[12] = [_createElementVNode("path", {
        d: "M6 9L42 9",
        stroke: "#333",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M6 19L42 19",
        stroke: "#333",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1), _createElementVNode("path", {
        d: "M6 26L24 40L42 26",
        stroke: "#333",
        "stroke-width": "4",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)]))], 544)), [[_vShow, _unref(pageData).showMin]]), _createVNode(_component_el_tooltip, {
        content: "显示小视图",
        placement: "right"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("svg", {
          class: "talkButton",
          onClick: _cache[9] || (_cache[9] = $event => _unref(onUpdateviewerClass)('showMin')),
          width: "24",
          height: "24",
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [...(_cache[13] || (_cache[13] = [_createElementVNode("path", {
          d: "M6 10L42 10",
          stroke: "#333",
          "stroke-width": "4",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1), _createElementVNode("path", {
          d: "M6 20L42 20",
          stroke: "#333",
          "stroke-width": "4",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1), _createElementVNode("path", {
          d: "M6 40L24 26L42 40",
          stroke: "#333",
          "stroke-width": "4",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, -1)]))], 512)), [[_vShow, !_unref(pageData).showMin]])]),
        _: 1
      })]);
    };
  }
};